import { FC, useCallback, useEffect, useState } from "react";
import {
    ActiveOptionHandler,
    Option,
    OptionList,
} from "../../../helpers/helpers";
import SearchBarSelectSprite from "./Img/SearchBarSelectSprite.svg";

import "./SearchBarSelect.scss";
import { WidthFormControl } from "../../../../models/models";
import ImageSprite from "../../ImageSprite/ImageSprite";

type SearchBarSelectProps = {
    label?: string;
    options: OptionList | undefined;
    activeOptionHandler: ActiveOptionHandler;
    name: string;
    widthFormControl: WidthFormControl;
    dateRange?: { startDate?: number; endDate?: number };
    resetTrigger?: boolean; // Новый пропс для сброса
};

enum ViewState {
    DEFAULT = "default",
    SELECTED = "selected",
}

export const SearchBarSelect: FC<SearchBarSelectProps> = ({
    options = [],
    activeOptionHandler,
    label,
    name,
    widthFormControl,
    resetTrigger,
}) => {
    const [currentOption, setCurrentOption] = useState<Option | undefined>();
    const [viewState, setViewState] = useState<ViewState>(ViewState.DEFAULT);

    const resetSelectHandler = useCallback(() => {
        if (viewState === ViewState.SELECTED) {
            activeOptionHandler(undefined);
            setCurrentOption(undefined);
            setViewState(ViewState.DEFAULT);
        }
    }, [activeOptionHandler, viewState]);

    useEffect(() => {
        if (resetTrigger) {
            resetSelectHandler();
        }
    }, [resetTrigger, resetSelectHandler]);

    const icon = viewState === ViewState.SELECTED ? "clean" : "arrow";

    return (
        <div className="form_control" style={{ maxWidth: widthFormControl }}>
            <label className="label">{label}</label>
            <div className="search_bar_select">
                <div
                    onClick={() => resetSelectHandler()}
                    view-state={viewState}
                    className="search_bar_select__caption unSelectable"
                >
                    <span className="search_bar_select__caption_name">
                        {currentOption ? currentOption.name : name}
                    </span>
                    <button className="action_button" type="button">
                        <ImageSprite
                            iconSprite={`${SearchBarSelectSprite}#${icon}`}
                        />
                    </button>
                </div>

                <div className="search_bar_select__popup">
                    <div className="search_bar_select__popup_container">
                        {options.map((option, id) => (
                            <li
                                className={`search_bar_select__option ${
                                    option.id === currentOption?.id
                                        ? "selected"
                                        : ""
                                }`}
                                key={id}
                                onClick={() => {
                                    setViewState(ViewState.SELECTED);
                                    activeOptionHandler(option);
                                    setCurrentOption(option);
                                }}
                            >
                                <div className="search_bar_select__option_content">
                                    <div className="search_bar_select__option_label">
                                        {option.name}
                                    </div>
                                </div>
                            </li>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};
